module.exports = __webpack_public_path__ + "static/img/introduction-environmental-strategy-our-six-pillars.6204a01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-environmental-strategy-our-six-pillars.jpg
// module id = x/Pd
// module chunks = 0